module.exports = __webpack_public_path__ + "img/FaqAlmode (1).1a7d2724.png";